import { render, staticRenderFns } from "./RecentResultItem.vue?vue&type=template&id=1512bc8c&scoped=true&"
import script from "./RecentResultItem.vue?vue&type=script&lang=js&"
export * from "./RecentResultItem.vue?vue&type=script&lang=js&"
import style0 from "./RecentResultItem.vue?vue&type=style&index=0&id=1512bc8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1512bc8c",
  null
  
)

export default component.exports